import { colorStrings } from "@bevco/Utilities/variables";
import { ButtonWrapper } from "@insite/mobius/Button";
import { TagPresentationProps } from "@insite/mobius/Tag";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const tag: RecursivePartial<{
    defaultProps?: TagPresentationProps | undefined;
}> = {
    defaultProps: {
        color: colorStrings.secondaryMain,
        iconProps: {
            size: 16,
            src: "XCircle",
        },
        typographyProps: {
            variant: "body",
            forwardAs: "span",
            size: 14,
            lineHeight: "30px",
            weight: 700,
            color: colorStrings.commonGlobalWhite,
            css: css`
                background-color: transparent;
            `,
        },
        mergeCss: true,
        css: css`
            display: flex;
            height: 50px;
            justify-content: space-between;
            align-items: center;
            align-self: stretch;
            padding: 10px 16px;
            gap: 10px;
            max-width: max-content;

            ${ButtonWrapper} {
                border-radius: 0;
                min-height: auto;
            }
        `,
    },
};
